import { NavLink } from 'react-router-dom';
import fb from './images/facebook.png'
import ig from './images/instagram.png'
import tw from './images/twitter.png'

import logo from './images/logo.png';
import '../App.scss';

export default function Footer() {
    return (
		<div>
			<div className='flex-row space-between align-top white' id="footer">
				<div className='flex-row align-top gap-80'>
					<div className="flex-col align-left gap-8">
						<h2 className="text-pink">About Us</h2>
						<NavLink to="/#">Home</NavLink>
						<NavLink to="/about">About MERL</NavLink>
						<NavLink to="/comingsoon">Articles</NavLink>
						{/* <NavLink>Contact</NavLink> */}
						{/* <NavLink>Press</NavLink> */}
					</div>
					<div className="flex-col align-left gap-8">
						<h2 className='text-pink'>Our Reviews</h2>
						<NavLink to="/scoring">How We Score</NavLink>
						<NavLink to="/search">Reviews</NavLink>
						<NavLink to="/comingsoon">Glossary</NavLink>
					</div>
				</div>
				<div className='align-right flex-col'>
					<a href="/"><img src={logo} alt="MERL Logo" id="navLogo"></img></a>
				</div>
			</div>
			<div className='white padding-bottom-48'>
				<p>© 2025 Media Education Research Lab</p>
			</div>
		</div>
    )

}

